import BASE_URL from '@naruto/bgdapp/src/base/url';
import GUEST_PAGE_KEY from '@naruto/bgdapp/src/base/routes/GuestPageKey';
import { Routes } from '@naruto/bgdapp/src/base/routes/types';

const GUEST_URL = BASE_URL.GUEST;

const GuestProject: Routes = {
  main: [
    {
      id: GUEST_PAGE_KEY.PROJECT_OVERVIEW,
      route: `${GUEST_URL.PAGE_PROJECT_OVERVIEW}`,
      component: import('@naruto/bgdapp/src/components/Pages/Project/ProjectOverview'),
      exact: false,
      showInSidebar: false,
      subRoute: [],
      lang: '',
      icon: '',
      iconActive: ''
    },
    {
      id: GUEST_PAGE_KEY.PROJECT_DETAIL,
      route: `${GUEST_URL.PAGE_PROJECT_DETAIL}`,
      component: import('@naruto/bgdapp/src/components/Pages/Project/ProjectDetail'),
      exact: false,
      showInSidebar: false,
      subRoute: [],
      lang: '',
      icon: '',
      iconActive: ''
    }
  ]
};

export default GuestProject;
